import React, { useEffect } from 'react';
import Navigation from 'src/components/navigation/navigation';
import NavigationLayout from 'src/components/navigation/navigation-layout';
import { useLocation } from "react-router-dom";
import { trackEvent } from '@/amplitudeClient';
import { AMPLITUDE_EVENT } from '@/utils/analytics';

const NavigationPage: React.FC = () => {
  const location = useLocation();
  const state = location.state as { referrer?: string } | null;
  let trackedEvent = false;
  useEffect(() => {
    if (!trackedEvent) {
      trackedEvent = true;
      trackEvent(AMPLITUDE_EVENT.NAV_PREVIEW_INTENT_STARTED);
    }
  }, [])

  return (
    <NavigationLayout children={<Navigation />} referrer={state?.referrer}></NavigationLayout>
  );
};

export default NavigationPage;